import { Sparkles } from "lucide-react";

import { cn } from "@/lib/utils";
import type { PageMode } from "@/hooks/usePageMode";

// Sprint 8 — Bouton bascule classique ↔ agent. À placer dans le header
// de chaque page refondue (dev / companies / appointments).

interface PageModeToggleProps {
  mode: PageMode;
  onToggle: () => void;
  className?: string;
}

export const PageModeToggle = ({
  mode,
  onToggle,
  className,
}: PageModeToggleProps) => {
  const isAgent = mode === "agent";
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={isAgent}
      className={cn(
        "inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-[12.5px] font-medium transition-colors shrink-0",
        isAgent
          ? "bg-violet-100 text-violet-900 hover:bg-violet-200 dark:bg-violet-900/40 dark:text-violet-200 dark:hover:bg-violet-900/60"
          : "bg-muted text-muted-foreground hover:text-foreground hover:bg-muted/80",
        className,
      )}
    >
      <Sparkles className="size-3.5" />
      {isAgent ? "Mode classique" : "Demander à l'agent"}
    </button>
  );
};
